import Axios from 'axios';

const http = Axios.create();
http.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

function isHttpError(e) {
  return Axios.isAxiosError(e);
}

export { http, isHttpError };
